<mat-list class="date" cdkFocusRegionStart>
  <h3 matSubheader cdkFocusInit>
    <span class="quick-panel-today">Today</span>
  </h3>
  <div class="secondary-text mat-display-1 mb0 p16">
    <div class="mb12">{{ date | date: 'EEEE' }}</div>
    <div fxLayout="row" fxLayoutAlign="start start">
      <span>{{ date | date: 'd' }}</span>
      <span class="mat-subheading-1">th</span>
      <span>{{ date | date: 'MMMM' }}</span>
    </div>
  </div>
</mat-list>

<mat-divider cdkFocusRegionEnd></mat-divider>

<mat-card class="example-card">
  <mat-card-header class="mat-primary-bg my-activity">
    <mat-card-title class="p8">My Activity</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <mat-list-item *ngFor="let activity of activityData">
        <mat-icon mat-list-icon>{{ activity?.type }}</mat-icon>
        <div mat-line>
          <span class="primary-fg">{{ activity?.author.username }}</span>
        </div>
        <div mat-line>{{ activity?.msg }}</div>
        <div mat-line>{{ activity?.createdAt | fromNow }}</div>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
